import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import {AuthHttp} from 'angular2-jwt';
//import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {tokenNotExpired} from 'angular2-jwt';
import {Observable} from 'rxjs/Rx';


import {AppSettings} from '../app-settings';

import 'rxjs/add/operator/catch';
import 'rxjs/observable/throw';

@Injectable()
export class ListingService {

  public token: string;
    header1 = new Headers({'Accept': 'application/json'});//'Content-Type':'multipart/form-data'},
    option1 = new RequestOptions({headers: this.header1});

  headers = new Headers({'Accept': 'application/json'});
  options = new RequestOptions({headers: this.headers});

  constructor(private http: Http, private authHttp: AuthHttp) {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
  }

  getAttendeeList(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/attendee/list", params, this.options).map(this.extractData)
        .catch(this.handleError);
  }

  getSupplierList(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/list", params, this.options).map(this.extractData)
        .catch(this.handleError);
  }

    getPackageList(params): Observable<any> {
        return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/package/package-list", params, this.options).map(this.extractData)
            .catch(this.handleError);
    }

  getDistributorList(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/distributor/list", params, this.options).map(this.extractData)
        .catch(this.handleError);
  }

  getGuestList(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/guest/list", params, this.options).map(this.extractData)
        .catch(this.handleError);
  }

  getEmailList(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/email/list", params, this.options).map(this.extractData)
        .catch(this.handleError);
  }

  saveEmail(params): Observable<any>{
    return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/email/send-email', params, this.options)
        .map(this.extractData)
        .catch(this.handleError);
  }

    getEventsInfo(params): Observable<any> {
        return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/admin/event-info", params, this.options).map(response => response.json().events);
    }

  getEmailHistotyList(params): Observable<any>{
    return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/email/send-email-history', params, this.options)
        .map(this.extractData)
        .catch(this.handleError);
  }

    getEmailName(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/email/send-email-names', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getPaymentList(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/payment/get-payment-list', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    addCheckAmt(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/payment/add-check-amount', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getDistributorDeatail(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/get-distributor-detail', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    updateStayInfo(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/update-stay-info', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getGuestDetail(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/get-guest-detail', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    approveRefund(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/payments/approve-refund', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    uploadList(params): Observable<any>{

        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/upload', params, this.option1)
            .map(this.extractData)
            .catch(this.handleError);
    }


    getSupplierDetail(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/get-supplier-detail', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getInfoAttendee(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/get-info-attendee', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getRefundList(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/get-refund-request-list', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    addAttendee(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/add-attendee', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    upgradePack(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/supplier/update-package', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getActivityInfo(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/get-activity-info', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getFullCancelDetail(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/get-full-cancel-info', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }



    cancelAttendee(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/cancel-attendee', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    addDiscount(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/add-discount', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getSplitAmt(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/get-discount-split', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

        getCards(params): Observable<any>{
            return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/get-cards', params, this.options)
                .map(this.extractData)
                .catch(this.handleError);
        }

        saveBalance(params): Observable<any>{
            return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/save-balance', params, this.options)
                .map(this.extractData)
                .catch(this.handleError);
        }

        getAttendeeInfo(params): Observable<any>{
            return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/get-attendee-info', params, this.options)
                .map(this.extractData)
                .catch(this.handleError);
        }

        updateDistributorAttendee(params): Observable<any>{
            return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/update-attendee-info', params, this.options)
                .map(this.extractData)
                .catch(this.handleError);
        }

    changeDistributorActivity(params): Observable<any> {
     return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/distributor/admin-change-activity", params, this.options).map(response => response.json());
    }

    getMongoSupplierList(): Observable<any> {
        return this.http.get("https://www.nissco.com/mongodb_server/public/api/v1/event-supplier-list").map(response => response.json());
    }

    getMongoDistributorList(): Observable<any> {
        return this.http.get("https://www.nissco.com/mongodb_server/public/api/v1/event-distributor-list").map(response => response.json());
    }
    

    changeDistributorActivityMail(params): Observable<any> {
     return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/distributor/admin-change-activity-mail", params, this.options).map(response => response.json());
    }

    changeGuestActivity(params): Observable<any> {
     return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/guest/admin-change-activity", params, this.options).map(response => response.json());
    }

    changeGuestActivityMail(params): Observable<any> {
     return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/guest/admin-change-activity-mail", params, this.options).map(response => response.json());
    }

    changeSupplierActivity(params): Observable<any> {
        return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/admin-change-activity", params, this.options).map(response => response.json());
    }

    changeSupplierActivityMail(params): Observable<any> {
     return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/admin-change-activity-mail", params, this.options).map(response => response.json());
    }

    changeAttendeeActivity(params): Observable<any> {
        return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/attendee/admin-change-activity", params, this.options).map(response => response.json());
    }

    updateTravelInfo(params): Observable<any> {
        return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/admin/update-travel-info", params, this.options).map(response => response.json());
    }

    getAttendeeDetail(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/attendee-detail-page', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    upgradeUser(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/supplier/update-package', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    changeSupplierFeature(params): Observable<any> {
        return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/admin-change-feature", params, this.options).map(response => response.json());
    }

    changeSupplierFeatureMail(params): Observable<any> {
        return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/admin-change-feature-mail", params, this.options).map(response => response.json());
    }

    fullCancel(params): Observable<any> {
        return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/admin/full-cancel", params, this.options).map(response => response.json());
    }

    getAdminDetail(params): Observable<any> {
        return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/admin/admin-detail", params, this.options).map(response => response.json());
    }

    updateAdmin(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/admin-info-update', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getfeedbackList(params): Observable<any>{
    return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/admin-feedback', params, this.options)
        .map(this.extractData)
        .catch(this.handleError);
    }
    







    private extractData(res: Response) {
    let body = res.json();
    //console.log(body);
    return body || [];
  }

  private handleError(error: Response | any) {
    return Observable.throw(<any>error);
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/listing.service.ts